import { useEffect, useState } from "react";
import { TicketPercent, X } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export function CouponBox({ params, applied, onApplied }) {
  const api = useApi();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const apply = async (c) => {
    if (!c.trim()) return;
    setBusy(true);
    setErr("");
    try {
      const r = await api.post("/coupons/check", { ...params, code: c.trim() });
      onApplied(r.data);
    } catch (e) {
      setErr(errMsg(e));
      onApplied(null);
    }
    setBusy(false);
  };

  useEffect(() => {
    const ref = localStorage.getItem("hc_ref");
    if (ref && !applied) { setCode(ref); apply(ref); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.car_id, params.pickup_at, params.return_at, params.protection, params.with_driver]);

  if (applied) {
    return (
      <div className="flex items-center justify-between rounded-2xl bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="coupon-applied">
        <span className="flex items-center gap-2"><TicketPercent className="h-4 w-4" /><b>{applied.coupon_code}</b> applied · you save ₹{applied.coupon_discount.toLocaleString("en-IN")}</span>
        <button type="button" onClick={() => { onApplied(null); setCode(""); localStorage.removeItem("hc_ref"); }} data-testid="coupon-remove" className="rounded p-1 hover:bg-emerald-100" aria-label="Remove code"><X className="h-4 w-4" /></button>
      </div>
    );
  }
  return (
    <div data-testid="coupon-box">
      <label className="block text-sm font-medium">Coupon or referral code</label>
      <div className="mt-1 flex gap-2">
        <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Enter code" data-testid="coupon-input"
          className="w-full rounded-xl border border-black/10 bg-white px-4 py-3 font-mono text-sm uppercase outline-none focus:ring-2 focus:ring-[#FF5A00]" />
        <button type="button" onClick={() => apply(code)} disabled={busy || !code.trim()} data-testid="coupon-apply"
          className="rounded-xl border border-black/10 px-5 text-sm font-semibold transition-colors duration-200 hover:border-[#FF5A00] hover:text-[#FF5A00] disabled:opacity-50">{busy ? "…" : "Apply"}</button>
      </div>
      {err && <p className="mt-1.5 text-xs text-rose-600" data-testid="coupon-error">{err}</p>}
    </div>
  );
}
